import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

const ABOUT_IMG = "/images/khalfan-about.jpeg";
const SECONDARY_IMG = "/images/oman-heritage.jpg";

export default function About() {
  const { t, pick } = useLang();
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);

  const long = pick(settings.about_long_en, settings.about_long_fr) || "";

  return (
    <div data-testid="about-page" className="pt-24 md:pt-28 pb-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="md:col-span-7">
            <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">{t.about_page.overline}</p>
            <h1 className="font-serif-display text-4xl md:text-6xl tracking-tight font-light text-charcoal leading-[1.05]">
              {t.about_page.title}
            </h1>
            <div className="mt-6 text-charcoal-400 text-base md:text-lg leading-relaxed whitespace-pre-line">
              {long}
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={ABOUT_IMG} alt="Khalfan" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center mt-16 md:mt-24">
          <div className="md:col-span-7 order-2 md:order-1">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={SECONDARY_IMG} alt="Oman heritage" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="md:col-span-5 order-1 md:order-2">
            <p className="text-xs uppercase tracking-[0.3em] text-terracotta mb-4">Why travel with me</p>
            <h2 className="font-serif-display text-3xl md:text-4xl tracking-tight font-light text-charcoal leading-[1.15]">
              Official guidance, real people, small groups.
            </h2>
            <ul className="mt-8 space-y-4 text-charcoal-400">
              <li className="flex gap-3"><span className="text-terracotta">·</span> Official guide certified by the Government of Oman.</li>
              <li className="flex gap-3"><span className="text-terracotta">·</span> Private 4x4, never shared.</li>
              <li className="flex gap-3"><span className="text-terracotta">·</span> Honest, fixed pricing per group.</li>
              <li className="flex gap-3"><span className="text-terracotta">·</span> Hospitality from my own family along the way.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
